import Vue from 'vue'
import App from './App.vue'
import router from './router'
import 'lib-flexible'
import store from './store'
import Vuex from 'vuex'
import axios from './utils/http'
import JSEncrypt from "jsencrypt"; 

import {
    Image as VanImage,
    Dialog,
    Progress,
    Popup,
    SwipeCell,
    Button,
    Loading,
    Overlay,
    Swipe,
    SwipeItem,
    Sticky,
    Tab,
    Tabs,
    NavBar,
    Calendar,
    Icon,
    Field,
    Uploader,
    Divider,
    Toast,
    Search,
    Checkbox,
    CheckboxGroup,
    Popover,

    RadioGroup,
    Radio,
    Notify,
    Form,
    ActionSheet,
    Cascader,
    TreeSelect
} from 'vant'
import 'vant/lib/index.css'

Vue.use(Dialog)
    .use(Progress)
    .use(Popup)
    .use(SwipeCell)
    .use(Button)
    .use(Loading)
    .use(Overlay)
    .use(Swipe)
    .use(VanImage)
    .use(Sticky)
    .use(SwipeItem)
    .use(Tab)
    .use(Tabs)
    .use(NavBar)
    .use(Calendar)
    .use(Icon)
    .use(Field)
    .use(Divider)
    .use(Uploader)
    .use(Toast)
    .use(Search)
    .use(Checkbox)
    .use(CheckboxGroup)
    .use(RadioGroup)
    .use(Radio)
    .use(Popover)
    .use(Notify)
    .use(Form)
    .use(ActionSheet)
    .use(Cascader)
    .use(TreeSelect)


Vue.prototype.$axios = axios
Vue.use(Vuex)
Vue.config.productionTip = false
Vue.prototype.jsEncrypt = JSEncrypt;//加密
Vue.mixin({
    //代码块，每一个vue实例都可以获得，比如data,computed,methods
    methods: {
        getLoginStatus() {
            let flag = false
            return flag
        },
    },
})

new Vue({
    router,
    store,
    render: (h) => h(App),
}).$mount('#app')